import { render, staticRenderFns } from "./GUserAvator.vue?vue&type=template&id=39f01230&"
import script from "./GUserAvator.vue?vue&type=script&lang=ts&"
export * from "./GUserAvator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports